import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCiRelation, updateCiRelation, deleteCiRelation } from "../services/ciRelationsApi";

export function useCreateCiRelation(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCiRelation,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      queryClient.setQueryData(queryData, (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      handleError?.(error);
    },
  });
}

export function useUpdateCiRelation(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCiRelation,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      queryClient.setQueryData(queryData, (old) =>
        old?.map((item) => (item.public_id === data.public_id ? data : item)),
      );
      //queryClient.invalidateQueries(queryData);
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      handleError?.(error);
    },
  });
}

export function useDeleteCiRelation(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCiRelation,
    onSuccess: (_, publicId) => {
      queryClient.setQueryData(queryData, (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.();
    },
    onError: (error) => {
      handleError?.(error);
    },
  });
}
